export enum ProductFeature {
  SweatWicking = 'Sweat-wicking',
  BootyLifting = 'Booty lifting',
  HighCompression = 'High compression',
  MediumCompression = 'Medium compression',
  WontRollDown = "Won't roll down",
  BootySmoothing = 'Booty smoothing',
  NoPantyLines = 'No panty lines',
  EasyOnOff = 'Easy on and off',
  FlexibleBoning = 'Flexible boning',
  UnderwireFree = 'Underwire-free',
  TargetedSmoothing = 'Targeted smoothing',
  DigFreeStraps = 'Dig-free straps',
  BackBulge = 'No back bulge',
  AdjustableStraps = 'Adjustable straps',
  BondedSupport = 'Bonded support',
  PrintedSupport = '3d printed support',
  AdjustableGusset = 'Adjustable gusset',
  WedgieProof = 'Wedgie-proof',
  PeekabooMesh = 'Peekaboo mesh',
  HighestCompression = 'Highest compression',
  ThreeSixtyBoning = '360° boning',
  HiddenShaping = 'Hidden shaping',
  SmoothingFabric = 'Smoothing fabric',
  StretchWaistband = 'Stretch waistband',
  WrinkleFree = 'Wrinkle-free',
  SheerProofFabric = 'Sheer-proof fabric',
  AbsorbentGusset = 'Absorbent gusset',
  ThreeSixtyBonding = '360° bonding',
  HighRecoveryStretch = 'High recovery stretch',
  HighWaistCut = 'High waist cut',
  NoBackBulge = 'No back bulge',
  GreatGift = 'Great gift',
  EmailDelivery = 'Email delivery',
}
